import { ReactElement, ReactNode, createContext, useContext } from 'react'

import { PortalName } from 'commons/types/enums'

import { LogoutHandler } from './hooks'

export type ContextShape = {
  hasSession: boolean
  themeName: string
  portalName: PortalName
  backgroundElement: ReactElement
  logoElement: ReactElement
  footer: ReactNode
  logout: LogoutHandler
}

export const AuthContext = createContext<ContextShape>({
  hasSession: false,
  themeName: 'BP',
  portalName: PortalName.BP,
  backgroundElement: null!,
  logoElement: null!,
  footer: '',
  logout: async () => {
    throw new Error('logout lost context or used outside context')
  }
})

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}
